<template>
    <div class="loading-wrapper d-flex align-items-center justify-content-center" style="height: 100vh;">
        <div class="card border-light" style="width: 18rem;">
            <div class="card-body text-center">
                <b-spinner :variant=spinner label="Spinning" :font-scale="spinnerSize" />
                <h5 class="card-title">{{ $t(title) }}</h5>
                <p class="card-text">
                    {{ $t(loadingText) }}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
          spinner: {
            type: String,
            default: () => "primary",
          },
          spinnerSize: {
            type: String,
            default: () => "10.5"
          },
          title: {
            type: String,
            default: () => "loading"
          },
          loadingText: {
            type: String,
            default: () => "loading-hierarchy"
          }
        },
        components: {
        },
        data() {
          return {
            
          };
        },
        methods: {
            
        },
      };
</script>